<template>
    <v-container fluid class="product-management mt-15 px-1">
        <div v-if="show == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-card>
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Búsqueda Avanzada</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon color="white">mdi-magnify</v-icon>
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid" lazy-validation ref="formreporte">
                    <v-row>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Número del Reporte:</span>
                            <v-text-field class="pt-2" v-model="busqueda.nrreporte" outlined width="20px" maxlength="10" dense autofocus ref="nrreporte" @change="validarReporte" @keypress="validarRegex($event, 'N')"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Estado: </span>
                            <multiselect style="border-color:brown !important"
                                         v-model="busqueda.estado"
                                         deselect-label="No se puede remover el valor seleccionado"
                                         selected-label="Seleccionado"
                                         select-label="Seleccione el estado"
                                         track-by="esclave" label="esnombre"
                                         placeholder="Seleccione una opción"
                                         :options="estados"
                                         :allow-empty="false"
                                         dense
                                         class="pt-2">
                            </multiselect>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Fecha Inicio:</span>
                            <v-menu v-model="menu1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="busqueda.fechaini"
                                                  class="pt-2"
                                                  readonly
                                                  outlined
                                                  dense
                                                  v-bind="attrs"
                                                  :error-messages="errorfechaini"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="busqueda.fechaini" :max="maxfecha" @input="menu1 = false" locale="es-mx"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="3" sm="12">
                            <span style="font-weight: bold;">Fecha Final:</span>
                            <v-menu v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="busqueda.fechafin"
                                                  class="pt-2"
                                                  readonly
                                                  outlined
                                                  dense
                                                  v-bind="attrs"
                                                  :required="validafechafin"
                                                  :error-messages="errorfechafin"
                                                  v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="busqueda.fechafin" :min="busqueda.fechaini" :max="maxfecha" @input="menu2 = false" locale="es-mx"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <div mt-2>
                    <v-btn class="mr-4" color="#536DFE" @click="numpag=1; pagina=1;BuscarIni(); " style="color:white" :disabled="(!validafechafin) == false">Buscar</v-btn>
                    <v-btn class="mr-4" @click="limpiar" color="default">Limpiar</v-btn>
                </div>
            </v-card-actions>
        </v-card>
        <v-card class="mt-2">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-3">mdi-magnify</v-icon>
                <p style="color: white;">Reportes</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <div class="table-responsive" v-if="Listado.length != 0">
                    <table id="tbvial" class="table table-hover display responsive no-wrap" width="100%">
                        <thead>
                            <tr>
                                <th></th>
                                <th v-for="encabezado in headers" :key="encabezado.id">
                                    {{ encabezado.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="reporte in Listado" :key="reporte.id">
                                <td></td>
                                <td><a class="link" @click="BuscarReporte(reporte)">{{ reporte.NumReporte }}-{{ reporte.Indice }}</a></td>
                                <!--<td>{{ reporte.Indice }}</td>-->
                                <td>
                                    <!--<span >Hola</span>-->
                                    <v-btn v-if="reporte.Captura == 'VERDE'" fab
                                           dark
                                           small
                                           color="success"></v-btn>
                                </td>
                                <td>
                                    <v-btn v-if="reporte.Turnado == 'VERDE'" fab
                                           dark
                                           small
                                           color="success"></v-btn>
                                    <v-btn v-else-if="reporte.Turnado == 'ROJO'" fab
                                           dark
                                           small
                                           color="error"></v-btn>
                                    <v-btn v-else-if="reporte.Turnado == 'AMARILLO'" fab
                                           dark
                                           small
                                           color="error"></v-btn>
                                </td>
                                <td>
                                    <v-btn v-if="reporte.Contacto == 'VERDE'" fab
                                           dark
                                           small
                                           color="success"></v-btn>
                                    <v-btn v-else-if="reporte.Contacto == 'ROJO'" fab
                                           dark
                                           small
                                           color="error"></v-btn>
                                    <v-btn v-else-if="reporte.Contacto == 'AMARILLO'" fab
                                           dark
                                           small
                                           color="error"></v-btn>
                                    <v-btn v-else-if="reporte.Contacto == 'BLANCO'" fab
                                           dark
                                           small
                                           color="white"></v-btn>
                                </td>
                                <td>
                                    <v-btn v-if="reporte.Termino == 'VERDE'" fab
                                           dark
                                           small
                                           color="success"></v-btn>
                                    <v-btn v-else-if="reporte.Termino == 'AMARILLO'" fab
                                           dark
                                           small
                                           color="error"></v-btn>
                                    <v-btn v-else-if="reporte.Termino == 'BLANCO'" fab
                                           dark
                                           small
                                           color="white"></v-btn>
                                </td>
                                <td>{{ reporte.NumSiniestro }}</td>

                                <td>{{ reporte.FhReporte }}</td>
                                <td>{{ reporte.FhTurnado }}</td>
                                <td>{{ reporte.FhEstimada }}</td>
                                <td>{{ reporte.FhContacto }}</td>
                                <td>{{ reporte.FhTermino }}</td>
                                <td>{{ reporte.Asistencia }}</td>
                                <td>{{ reporte.Estado }}</td>
                                <td>{{ reporte.Proveedor }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <span v-if="Listado.length == 0">{{texto}}</span>
                <div v-if="Listado.length != 0">
                    <template>
                        <v-row>
                            <v-col cols="12" md="6" sm="12">
                                <div style="justify-content: center;" class="ml-2 text-center select-registros">
                                    <label>Ver</label>
                                    <v-select v-model="numreg" :items="regpagina" style="max-width:60px" class="ml-3 mr-1 my-custom-select" name="numreg" id="numreg"></v-select>
                                    <label>registros</label>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" sm="12">
                                <div class="pt-2">
                                    <v-pagination v-model="pagina" :length="numpaginas" :total-visible="5" name="pagina" id="pagina"></v-pagination>
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import viales from '@/services/Viales/viales.service.js';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';

    import "jquery/dist/jquery.min.js";
    
    import "datatables.net-dt/js/dataTables.dataTables";
    import "datatables.net-dt/css/jquery.dataTables.min.css";
    import $ from "jquery";
    import 'datatables.net-responsive-dt'
    import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

    export default {
        data() {
            return {
                valid: true,
                menu1: false,
                menu2: false,
                date: new Date().toISOString().substr(0, 10),
                maxfecha: new Date().toISOString(),
                busqueda: {
                    nrreporte: null,
                    fechaini: null,
                    fechafin: null,
                    estado: '',
                },
                estados: [],
                validafechaInicio: true,
                validafechafin: false,
                errorfechafin: null,
                errorfechaini: null,
                pagina: 1,
                numreg: 20,
                numpaginas: 0,
                numpag: 1,
                regpagina: [
                    { text: '20', value: 20 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                ],
                headers: [
                    { text: 'Reporte Ind', value: 'NumReporte', class: "text title" },
                    { text: 'Captura', value: 'Captura', class: "text title" },
                    { text: 'Turnado', value: 'Turnado', class: "text title" },
                    { text: 'Contacto', value: 'Contacto', class: "text title" },
                    { text: 'Termino', value: 'Termino', class: "text title" },
                    { text: 'Número de Siniestro', value: 'NumSiniestro', class: "text title" },
                    { text: 'Fecha del Reporte', value: 'FhReporte', class: "text title" },
                    { text: 'Fecha de Turnado', value: 'FhTurnado', class: "text title" },
                    { text: 'Fecha de Estimada', value: 'FhEstimada', class: "text title" },
                    { text: 'Fecha de Contacto', value: 'FhContacto', class: "text title" },
                    { text: 'Fecha de Termino', value: 'FhTermino', class: "text title" },
                    { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                    { text: 'Estado', value: 'Estado', class: "text title" },
                    { text: 'Proveedor', value: 'Proveedor', class: "text title" },
                ],
                Listado: [],
                registros: 0,
                show: false,
                tabla: false,
                texto: '',
                Total: [],
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            }
        },
        watch: {
            async 'busqueda.fechaini'(val) {
                if (val != null && val != '') {
                    this.numpaginas = 0;
                    this.validafechaInicio = false
                    this.errorfechaini = '';
                    this.errorfechafin = 'El campo es requerido';
                    this.validafechafin = true;
                } else if (this.busqueda.fechafin == null) {
                    this.validafechaInicio = false
                    this.errorfechafin = 'El campo es requerido';
                    this.validafechafin = true;
                }
            },
            async 'busqueda.fechafin'(val) {
                if (val == '') {
                    this.numpaginas = 0;
                    this.validafechafin = false
                    this.errorfechafin = ''
                }
                else if (val != null && this.busqueda.fechaini == null) {
                    this.validafechaInicio = true;
                    this.errorfechaini = 'El campo es requerido';
                    this.busqueda.fechafin = null;
                }
                else {
                    this.numpaginas = 0;
                    this.validaciofechafin = null
                    this.validafechafin = false
                    this.errorfechafin = ''
                }
            },
            'busqueda.nrreporte'() {
                this.numpaginas = 0;
            },
            pagina(nuevoValor) {
                this.show = true;
                this.numpag = nuevoValor
                this.tabla = false;
                this.Buscar()
            },
            numreg(nuevoValor) {
                if (this.Total[0].total > 20) {
                    this.numreg = nuevoValor
                    this.tabla = false;
                    this.numpag = 1
                    this.BuscarIni()
                }
            },
        },
        methods: {
            async BuscarIni() {
                this.tabla = false;
                let valfecha = false;
                if ((this.busqueda.fechaini == null && this.busqueda.fechafin == null))
                    valfecha = true;
                else if ((this.busqueda.fechaini == '' && this.busqueda.fechafin == ''))
                    valfecha = true;
                else if ((this.busqueda.fechaini == null && this.busqueda.fechafin == ''))
                    valfecha = true;

                if (this.busqueda.nrreporte == null && this.busqueda.estado == '' && valfecha) {
                    this.$swal({
                        position: 'center',
                        icon: 'info',
                        title: 'Datos incompletos',
                        text: 'Debe de llenar por lo menos un campo',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        timer: 2500
                    }).then((result) => {
                        if (result.isConfirmed) {

                        }
                    });
                }
                else {
                    this.show = true;
                    let formdata = new FormData();
                    formdata.append("reporte", this.busqueda.nrreporte);
                    formdata.append("esclave", this.busqueda.estado.esclave);
                    formdata.append("fechaini", this.busqueda.fechaini);
                    formdata.append("fechafin", this.busqueda.fechafin);
                    formdata.append("numreg", this.numreg);
                    formdata.append("numpag", this.numpag);
                    this.Total = await viales.ObtenerReportesVialRegistros(this, formdata);
                    this.numpaginas = this.Total[0].paginas;
                    this.Listado = [];
                    if (this.numpaginas > 0)
                        this.Buscar();
                    else {
                        this.texto = 'No se encontró registros';
                        this.Listado = [];
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            text: 'No se encontró registro',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 2500
                        }).then((result) => {
                            if (result.isConfirmed) {

                            }
                        });
                        this.show = false;
                    }

                }

            },
            async Buscar() {
                let formdata = new FormData();
                formdata.append("reporte", this.busqueda.nrreporte);
                formdata.append("esclave", this.busqueda.estado.esclave);
                formdata.append("fechaini", this.busqueda.fechaini);
                formdata.append("fechafin", this.busqueda.fechafin);
                formdata.append("numreg", this.numreg);
                formdata.append("numpag", this.numpag);
                await viales.ObtenerReportesVial(this, formdata).then(data => {
                    if (data.length > 0) {
                        this.tabla = true;
                        this.Listado = data;
                        $('#tbvial').DataTable().destroy();
                        setTimeout(() => {
                            $("#tbvial").DataTable({
                                paging: false,
                                lengthMenu: [
                                    [20, 50, 100],
                                    [20, 50, 100],
                                ],
                                columnDefs: [{
                                    className: 'dtr-control',
                                    orderable: false,
                                    targets: 0
                                }],
                                searching: false,
                                paginate: this.paginacion,
                                pageLength: this.numreg,
                                responsive: true,
                                "language": {
                                    "sProcessing": "Procesando...",
                                    "sLengthMenu": "Mostrar _MENU_ registros",
                                    "sZeroRecords": "No se encontraron resultados",
                                    "sEmptyTable": "Ningún dato disponible en esta tabla",
                                    "sInfo": "",
                                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                                    "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                                    "sInfoPostFix": "",
                                    "sSearch": "Buscar:",
                                    "sUrl": "",
                                    "sInfoThousands": ",",
                                    "sLoadingRecords": "Cargando...",
                                    "oPaginate": {
                                        "sFirst": "Primero",
                                        "sLast": "Último",
                                        "sNext": "Siguiente",
                                        "sPrevious": "Anterior"
                                    },
                                    "oAria": {
                                        "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                                    }
                                }
                            });
                        });
                    }
                    else {

                        this.Listado = [];
                        this.$swal({
                            position: 'center',
                            icon: 'info',
                            text: 'No se encontró registro',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 2500
                        }).then((result) => {
                            if (result.isConfirmed) {

                            }
                        });
                    }
                });

                this.show = false

            },
            validarReporte: function (e) {
                this.aux_nrreporte = e
                this.nrreporte = this.aux_nrreporte.split("-")
                this.nrreporte = this.nrreporte[0]
            },
            validarRegex(evt, tipo) {
                return MetodosGenerales.validarRegex(evt, tipo);
            },
            async BuscarReporte(item) {
                let reporte = {
                    nrreporte: item.NumReporte,
                    svindice: item.Indice,
                    aiclave: item.aiclave,
                    svfhconclusion: item.svfhconclusion
                }

                let routerName = await MetodosGenerales.obtenerRouterName(parseInt(item.aiclave));
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

                let url = this.$router.resolve({ name: `${routerName}`, params: { id: 0, } });
                window.open(url.href, '_blank');
            },
            limpiar() {
                this.texto = 'Sin registros';
                this.Listado = [];
                this.$refs.formreporte.reset();
                this.busqueda.estado = '';
                this.busqueda.fechafin = '';
                //this.busqueda.fechaini = '';
                this.tabla = false;
                this.validafechafin = false;
                this.validafechaInicio = false;
            },
        },
        async mounted() {
            this.$refs.nrreporte.focus()
            await viales.ObtenerEstados(this).then(data => {
                this.estados = data;
            });
        }
    }
</script>
<style scoped>
    .select-registros {
        display: flex;
        justify-content: left;
        align-items: baseline;
    }

    .my-custom-select .v-select__slot {
        height: 30px;
        font-size: 14px;
    }

    @media screen and (max-width: 767px) {
        .select-registros {
            display: flex;
            justify-content: center;
            align-items: baseline;
        }

        .div-paginacion {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>